module.exports = __webpack_public_path__ + "static/media/Seawatergreenhouseaus_crop3_desktop.2741962f.jpg";